<div class="html-overflow">
    <div class="w-h-label html-overflow" *ngIf="withLabel">
        {{ label | translate }}
    </div>
    <div class="html-overflow">
        {{ workStepDOM?.title ? workStepDOM?.title : '-' }}
    </div>
</div>